import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SpFormControlsModule } from '@components/sp-form-controls';

@Component({
    selector: 'web-widget-hide-settings',
    templateUrl: './web-widget-hide-settings.component.html',
    styleUrls: ['./web-widget-hide-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpFormControlsModule, TranslateModule],
})
export class WebWidgetHideSettingsComponent {
    @Input() public hideOnMobile: boolean;
    @Input() public hideOnTablet: boolean;
    @Input() public hideOnDesktop: boolean;

    @Output() public hideOnMobileChange: EventEmitter<boolean> = new EventEmitter();
    @Output() public hideOnTabletChange: EventEmitter<boolean> = new EventEmitter();
    @Output() public hideOnDesktopChange: EventEmitter<boolean> = new EventEmitter();

    public onHideOnMobileChange(value: boolean): void {
        this.hideOnMobileChange.emit(value);
    }

    public onHideOnTabletChange(value: boolean): void {
        this.hideOnTabletChange.emit(value);
    }

    public onHideOnDesktopChange(value: boolean): void {
        this.hideOnDesktopChange.emit(value);
    }

    public get hideOnMobileValue(): boolean {
        return this.hideOnMobile ?? false;
    }

    public get hideOnTabletValue(): boolean {
        return this.hideOnTablet ?? false;
    }

    public get hideOnDesktopValue(): boolean {
        return this.hideOnDesktop ?? false;
    }
}
